import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, watch } from "vue"
import { Paginate } from "@/types"


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    value: null,
    inline: { type: Boolean, default: true },
    resource: { default: "Projects" },
    color: { default: "transparent" }
  },
  emits: ["change", "input"],
  setup(__props: any, { emit }) {

const props = __props as { value: Paginate, inline: boolean, resource: string, color: string }



const form = ref<Paginate>(props.value)



const itemsPerPage = ref<number[]>([10, 15, 20, 30])

const cols = computed(() => {
  return props.inline ? 6 : 12
})

watch(form, () => {
  emit("change", form.value)
  emit("input", form.value)
})

onMounted(() => {
  form.value = { ...props.value }
  itemsPerPage.value = [...new Set([props.value.per, 10, 15, 20, 30])]
})

return { __sfc: true,props, form, emit, itemsPerPage, cols }
}

})